import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '@templatean/shared/hooks'

const HomePage: React.FC = () => {
  const { user } = useAuth()

  return (
    <div className="home-page">
      <div className="welcome-section">
        <h1>Welcome to Templatean for PowerPoint</h1>
        <p>Hello {user?.fullName}, create stunning presentations with AI-powered assistance.</p>
      </div>

      <div className="features-grid">
        <Link to="/builder" className="feature-card">
          <div className="feature-icon">🤖</div>
          <h3>AI Presentation Builder</h3>
          <p>Generate complete presentations from a topic description.</p>
        </Link>

        <Link to="/templates" className="feature-card">
          <div className="feature-icon">🎨</div>
          <h3>Slide Templates</h3>
          <p>Professional slide designs for every presentation need.</p>
        </Link>

        <Link to="/design" className="feature-card">
          <div className="feature-icon">🎯</div>
          <h3>Design Studio</h3>
          <p>Themes, colors, fonts, and brand assets management.</p>
        </Link>

        <Link to="/settings" className="feature-card">
          <div className="feature-icon">⚙️</div>
          <h3>Settings</h3>
          <p>Configure preferences and manage your account settings.</p>
        </Link>
      </div>

      <div className="quick-tips">
        <h2>Quick Tips</h2>
        <ul>
          <li>Describe your presentation topic and let AI create the outline</li>
          <li>Choose from professional slide templates for consistency</li>
          <li>Apply themes and color schemes with one click</li>
          <li>Add speaker notes automatically generated by AI</li>
        </ul>
      </div>

      <div className="stats-overview">
        <h2>PowerPoint Features</h2>
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-value">AI</div>
            <div className="stat-label">Presentation Builder</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">100+</div>
            <div className="stat-label">Slide Templates</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">20+</div>
            <div className="stat-label">Design Themes</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomePage